module.exports = __webpack_public_path__ + "img/boule_de_neige_virbunum_opulus.c8e93fd3.jpg";